<template>
  <div class="footer">
    <div class="copyright">
      <p>
        Copyright 2025 by &amp;
        <a href="javascript:void(0);" class="text-primary">Explore2Teach </a>
        <span class="current-year">All rights Reserved</span>
      </p>
    </div>
    <Chatbot/>
  </div>
</template>

<script>
import Chatbot from "@/components/Chatbot.vue";
export default {
  components: {
    Chatbot,
  },
  props: ["pageContent"],
};
</script>